import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import { ReactComponent as Cross } from '@jetshop/ui/svg/Cross.svg';
import React from 'react';
import styled from 'react-emotion';
import useShopId from '../../../utils/useShopId';
import { AnimatedButton } from '../../ui/AnimatedLink';
import { SmallButton } from '../../ui/Button';

export const FilterGroup = styled('div')`
  font-size: 0.875rem;
`;

export const AppliedFilter = styled('button')`
  color: ${({ theme }) => theme.colors.almostBlack};
  font-weight: 500;
  font-size: 0.9375rem;
  letter-spacing: 0.01em;
  text-transform: capitalize;

  border: 0;
  padding-left: 0.875rem;
  margin: 0 0.375rem 0.375rem;
  display: inline-flex;
  background-color: ${({ theme }) => theme.colors.beige};
  height: 30px;
  align-items: center;

  > label {
    cursor: pointer;
  }

  :focus {
    outline: none;
  }

  > span {
    padding-right: 0.875rem;
    padding-left: 0.25rem;
  }

  .close-container {
    background-color: ${({ theme }) => theme.colors.beige};
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    transition: 150ms;

    svg use {
      fill: ${({ theme }) => theme.colors.almostBlack};
    }
  }

  :hover .close-container {
    background-color: ${({ theme }) => theme.colors.darkBeige};
  }
`;

export const FilterWrapper = styled('aside')`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.375rem 0.4375rem;
  justify-content: center;
  ${({ theme }) => theme.below.md} {
    justify-content: flex-start;
  }
`;

export const ClearButton = styled(SmallButton)`
  height: 30px;
  margin: 0 0.375rem 0.375rem;
  padding: 0 0.875rem;
`;

export function ActiveFilters({ filters }) {
  const { clearAllFilters } = useFilters();
  const isEztrad = useShopId() === 'eztrad';

  if (!filters) return null;

  const activeListFilters = filters.filter(listFilter => {
    return listFilter.hasActiveItems;
  });

  if (activeListFilters.length === 0) return null;

  return (
    <FilterWrapper className="active-filters">
      {activeListFilters.map(listFilter => {
        return (
          <FilterGroup key={listFilter.id}>
            {listFilter.items
              .filter(item => item.isActive)
              .map(listFilterItem => (
                <ActiveListFilterItem
                  item={listFilterItem}
                  listFilter={listFilter}
                  key={listFilterItem.value}
                />
              ))}
          </FilterGroup>
        );
      })}
      {isEztrad ? (
        <div className="clear-button-container">
          <AnimatedButton
            className="clear-button"
            type="button"
            onClick={clearAllFilters}
          >
            {t('Clear filters')}
          </AnimatedButton>
        </div>
      ) : (
        <ClearButton
          className="clear-button"
          type="button"
          onClick={clearAllFilters}
        >
          {t('Clear filters')}
        </ClearButton>
      )}
    </FilterWrapper>
  );
}

function ActiveListFilterItem({ item, listFilter }) {
  const { apply } = useListFilter({ filter: listFilter });
  return (
    <AppliedFilter
      type="button"
      className="active-filter"
      key={item.value}
      onClick={() => {
        apply({ value: item.value });
      }}
    >
      <label>{listFilter.name} </label>
      <span>{item.text}</span>
      <div className="close-container">
        <Cross />
      </div>
    </AppliedFilter>
  );
}
